import { render, staticRenderFns } from "./List.vue?vue&type=template&id=c21a6868"
import script from "./List.js?vue&type=script&lang=js&external"
export * from "./List.js?vue&type=script&lang=js&external"
import style0 from "./List.vue?vue&type=style&index=0&id=c21a6868&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports